import { required, useGetList } from "react-admin";
import { InvoiceType, ProductReadModel } from "../../GeneratedClients/FreeBillApi"
import { useFormContext } from "react-hook-form";
import isInvoiceWithoutTax from "../../domain/invoice/isInvoiceWithoutTax";
import { CustomAutocompleteInput } from "./CustomAutocompleteInput";

interface IProps {
  getSource?: ((source: string) => string)
  invoiceType: InvoiceType
  isSmallBusiness?: boolean
}

const ProductInput = ({getSource, invoiceType, isSmallBusiness}: IProps) => {
  const { data: products, isLoading: productsLoading} = useGetList(
    'products', 
    {sort: {field: "productName", order: "ASC"}, pagination: {page: 1, perPage: 1000}}
  )
  const { setValue } = useFormContext()
  if(productsLoading) return null

  const handleChange = (newProductName: string) => {
    const newProduct: ProductReadModel = findProductByCompanyName(newProductName)
    setValues(newProduct)
  }

  const handleInputChange = (event: any, newInputValue: string) => {
    const existingProduct = findProductByCompanyName(newInputValue)
    if(existingProduct)
    {
      setValues(existingProduct)
    }
    else
    {
      const newProduct: ProductReadModel = {
        productName: newInputValue,
        price: 0,
        tax_in_percent: isInvoiceWithoutTax(invoiceType, isSmallBusiness) ? 0 : 0.19
      }
      setValues(newProduct)
    }
  }

  const setValues = (newValue: ProductReadModel) => {
    if(getSource) {
      setValue(getSource('itemName'), newValue?.productName)
      setValue(getSource('description'), newValue?.description)
      setValue(getSource('price'), newValue?.price)
      setValue(getSource('tax_in_percent'), isInvoiceWithoutTax(invoiceType, isSmallBusiness) ? 0 : newValue?.tax_in_percent)  
    }
  }

  const findProductByCompanyName = (productName:string) => {
    return products?.find((product: ProductReadModel) => (product.productName === productName))
  }


  return (
    <CustomAutocompleteInput 
      helperText={false} 
      clearOnBlur={false}
      onChange={handleChange}
      onInputChange={handleInputChange}
      validate={required()}
      source={getSource && getSource('itemName')}
      choices={products}
      optionText="productName"
      optionValue="productName"
      label="resources.products.productName"
    />
  )
}

export default ProductInput